/**
 * ブラウザキャッシュ対策用のランダム文字列を取得する
 */
function getNoCacheRandomString() {
  return new Date().getTime();
}

export default getNoCacheRandomString;



// WEBPACK FOOTER //
// ./es6/admin-common-js/utils/URLUtiles.js